import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '@ebw-monorepo/login';
import { forkJoin, Observable } from 'rxjs';
import { API_URLS, ApiUrlService } from '../../../../utils/src/lib/services/api-url.service';
import {
  FiltriComuniRequest,
  HeatmapCella,
  OpzioneComune,
  PuntiRischioRequest,
  PuntiRischioResponse,
  PuntoDettaglioResponse,
  Q95ClassCountRow,
  TipoPuntoCampionamentoLookup
} from '../models/rischio-analitico.model';

/**
 * Servizio per la sezione "Monitoraggio rischio analitico" del PSA: colorazione punti,
 * heatmap/riepilogo (sempre 95° percentile) e dettaglio trend+distribuzione per punto+parametro.
 */
@Injectable({
  providedIn: 'root'
})
export class RischioAnaliticoService {
  constructor(
    private _http: HttpClient,
    private _loginService: LoginService,
    private _apiUrlService: ApiUrlService
  ) { }

  get _headers(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this._loginService.getToken()
    });
  }

  // ------------------------------------------------------------------------------------------------

  public getPunti(body: PuntiRischioRequest): Observable<PuntiRischioResponse> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.RISCHIO_PUNTI);
    const headers = { headers: this._headers };
    return this._http.post<PuntiRischioResponse>(url, body, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public getHeatmap(body: FiltriComuniRequest): Observable<HeatmapCella[]> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.RISCHIO_HEATMAP);
    const headers = { headers: this._headers };
    return this._http.post<HeatmapCella[]>(url, body, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public getRiepilogo(body: FiltriComuniRequest): Observable<Q95ClassCountRow[]> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.RISCHIO_RIEPILOGO);
    const headers = { headers: this._headers };
    return this._http.post<Q95ClassCountRow[]>(url, body, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public getDettaglioPunto(uuid: string, codiceParametro: string, dataInizio?: string, dataFine?: string): Observable<PuntoDettaglioResponse> {
    const url = `${this._apiUrlService.createUrl(API_URLS.CONTROLLI.RISCHIO_PUNTO_DETTAGLIO)}/${uuid}/dettaglio`;
    let params = new HttpParams().set('codiceParametro', codiceParametro);
    if (dataInizio) params = params.set('dataInizio', dataInizio);
    if (dataFine) params = params.set('dataFine', dataFine);
    const headers = { headers: this._headers, params };
    return this._http.get<PuntoDettaglioResponse>(url, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public getDettaglioPuntoMulti(uuid: string, codiciParametro: string[], dataInizio?: string, dataFine?: string): Observable<PuntoDettaglioResponse[]> {
    return forkJoin(codiciParametro.map((codice) => this.getDettaglioPunto(uuid, codice, dataInizio, dataFine)));
  }

  // ------------------------------------------------------------------------------------------------

  public getTipologiePuntoCampionamento(): Observable<TipoPuntoCampionamentoLookup[]> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.TIPOLOGIE_PUNTO_CAMPIONAMENTO);
    const headers = { headers: this._headers };
    return this._http.get<TipoPuntoCampionamentoLookup[]>(url, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public getComuni(): Observable<OpzioneComune[]> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.RISCHIO_COMUNI);
    const headers = { headers: this._headers };
    return this._http.get<OpzioneComune[]>(url, headers);
  }
}
